const Icons = {
  Ic_cityscapes: '/Home/Ic_cityscapes.jpg',
  master_slider_left: '/Home/master-slider-left.webp',
  Ic_jet: '/Home/Ic_jet.jpg',
  Ic_abstract: '/Home/Ic_abstrac.jpeg',
  Ic_oiltankers: '/Home/Ic_oiltankers.jpg',
  Ic_financial: '/Home/Ic_financia.jpeg',
  Ic_futuristic: '/Home/Ic_futuristic.jpg',
  Ic_lion: '/Home/Ic_lion.jpg',
  Ic_oiltanker: '/Home/Ic_oiltanker.jpg',
  Ic_time: '/Home/Ic_time.jpg',
  Ic_bitcoin: '/Home/Ic_bitcoin.jpg',
  Ic_location: '/Home/Ic_location.jpg',
  Ic_investment: '/Home/Ic_investment.jpg',
  Ic_buildings: '/Home/Ic_buildings.jpg',
  Ic_lionOne: '/Home/Ic_lionOne.jpg',
  SK: '/Home/SK.mp4',
  Ic_Transactions: '/Home/Ic_Transactions.jpg',
  Ic_provide: '/Home/Ic_provide.mp4',
  Ic_finance: '/Home/Ic_finance.mp4',
  Ic_map: '/Home/Ic_map.jpg',
  Ic_sectors: '/Home/Ic_sectors.jpg',
  logo: '/Home/logo.png',
}
export default Icons
